import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaUsers, FaFingerprint, FaArrowRight } from "react-icons/fa";
import config from "../config";
import AdminSidebarShell from "./AdminSidebarShell";

const CreateGroup = () => {
  const [groups, setGroups] = useState([]);
  const [error, setError] = useState("");

  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const groupsBaseUrl = `${config.API_BASE_URL}/admin/groups`;

  const fetchGroups = async () => {
    try {
      const res = await axios.get(groupsBaseUrl, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setGroups(Array.isArray(res.data) ? res.data : []);
    } catch {
      setError("Failed to load your group");
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  const primaryGroup = groups[0] || null;

  return (
    <AdminSidebarShell activeItem="groupadmin">
      <div style={contentWrapper}>
        <div style={topBar}>
          <h1 style={pageTitle}>Group Administration</h1>
          <p style={pageSubtitle}>Select your group to invite members.</p>
        </div>

        {error ? <p style={errorStyle}>{error}</p> : null}

        <div style={groupCard}>
          <h2 style={cardTitle}>
            <FaUsers style={{ marginRight: "8px" }} />
            My Group
          </h2>

          {primaryGroup ? (
            <button
              type="button"
              style={groupButton}
              onClick={() => navigate(`/admin/groups/${primaryGroup.id}`)}
            >
              <span style={groupName}>{primaryGroup.name}</span>
              <span style={groupInstruction}>Click on your group to invite members</span>
            </button>
          ) : (
            <div style={emptyState}>
              <p style={emptyTitle}>No group available yet.</p>
              <p style={emptyText}>Create your Family Circle group to start inviting members.</p>
            </div>
          )}
        </div>

        <div style={actionGrid}>
          <button type="button" style={actionCard} onClick={() => {}}>
            <div style={actionIconWrap}>
              <FaUsers />
            </div>
            <div style={actionBody}>
              <h2 style={actionTitle}>Create Group Visual</h2>
              <p style={actionText}>A personalized Family Circle group visual will appear here.</p>
            </div>
            <FaArrowRight style={actionArrow} />
          </button>

          <button type="button" style={actionCard} onClick={() => {}}>
            <div style={actionIconWrap}>
              <FaFingerprint />
            </div>
            <div style={actionBody}>
              <h2 style={actionTitle}>Add Biometrics</h2>
              <p style={actionText}>Set up biometric services for your group members here.</p>
            </div>
            <FaArrowRight style={actionArrow} />
          </button>
        </div>
      </div>
    </AdminSidebarShell>
  );
};

export default CreateGroup;

const contentWrapper = {
  maxWidth: "920px",
  margin: "0 auto",
  fontFamily: "system-ui, -apple-system, sans-serif"
};

const topBar = {
  marginBottom: "24px"
};

const pageTitle = {
  margin: 0,
  fontSize: "28px",
  color: "#1e293b"
};

const pageSubtitle = {
  margin: "8px 0 0",
  color: "#64748b",
  fontSize: "15px"
};

const groupCard = {
  background: "#ffffff",
  padding: "28px",
  borderRadius: "18px",
  boxShadow: "0 10px 28px rgba(14,85,128,0.08)",
  border: "1px solid #e2e8f0",
  marginBottom: "20px"
};

const actionGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardTitle = {
  fontSize: "20px",
  fontWeight: "700",
  color: "#1e293b",
  margin: "0 0 20px 0",
  display: "flex",
  alignItems: "center"
};

const groupButton = {
  width: "100%",
  border: "1px solid #d9e5ef",
  borderRadius: "16px",
  background: "#f8fbfe",
  padding: "18px 20px",
  display: "grid",
  gap: "6px",
  textAlign: "left",
  cursor: "pointer",
  transition: "border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease"
};

const groupName = {
  fontSize: "22px",
  fontWeight: "700",
  color: "#0E5580"
};

const groupInstruction = {
  fontSize: "14px",
  color: "#64748b"
};

const emptyState = {
  border: "1px dashed #d8e4ee",
  borderRadius: "16px",
  padding: "24px",
  background: "#fbfdff"
};

const emptyTitle = {
  margin: 0,
  color: "#334155",
  fontWeight: "700"
};

const emptyText = {
  margin: "8px 0 0",
  color: "#64748b",
  fontSize: "14px"
};

const actionCard = {
  background: "#ffffff",
  padding: "28px",
  borderRadius: "18px",
  boxShadow: "0 10px 28px rgba(14,85,128,0.08)",
  border: "1px solid #e2e8f0",
  display: "flex",
  alignItems: "flex-start",
  gap: "16px",
  textAlign: "left",
  cursor: "pointer",
  width: "100%"
};

const actionIconWrap = {
  width: "52px",
  height: "52px",
  borderRadius: "14px",
  background: "#e8f3fb",
  color: "#0E5580",
  display: "grid",
  placeItems: "center",
  fontSize: "22px",
  flexShrink: 0
};

const actionBody = {
  flex: 1
};

const actionTitle = {
  margin: 0,
  color: "#0E5580",
  fontSize: "22px",
  fontWeight: "700"
};

const actionText = {
  margin: "8px 0 0",
  color: "#64748b",
  fontSize: "14px"
};

const actionArrow = {
  color: "#94a3b8",
  fontSize: "18px",
  marginTop: "6px",
  flexShrink: 0
};

const errorStyle = {
  color: "#dc2626",
  fontSize: "14px",
  margin: "0 0 16px",
  padding: "12px",
  background: "#fef2f2",
  borderRadius: "8px",
  border: "1px solid #fee2e2"
};
